import { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useForm, SubmitHandler } from "react-hook-form";
import { DateAndTimeStore } from "../Stores/DateAndTimeSlotStoreClass";
import { ApiClient, ApiResponse } from "./Api/ApiClient";
import { SystemMessage } from "./SystemMessage";


export type InputsFromForm = {
    //email: string,
    name: string,
    //lastName: string,
    phone: number,
    //GDPR: boolean, //TODO
    occupationalMedicalCheckUp: boolean,
    reasonForVisit: string
}


const noticeNonFilled: string = "Toto pole je nutné vyplnit"
const cbNotChecked: string = "Ten checkbox je nutné zatrhnout"
const reg = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;


export const ContactForm = () => {

    const [responseMessage, setResponseMessage] = useState<string>('');
    const { register, handleSubmit, formState: { errors } } = useForm<InputsFromForm>();
    const date = DateAndTimeStore.date;
    const timeSlot = DateAndTimeStore.timeSlot;

    const onSubmit: SubmitHandler<InputsFromForm> = async data => {
        //setUserData(data);
        // console.log(`UserData: ${data}`);
        // console.log(`Date: ${date}`);
        // console.log(`Timeslot: ${timeSlot}`);
        if (!date || !timeSlot) {
            throw new Error("Date or TimeSlot is missing!")
        }
        const result = await ApiClient.sendNewReservation(data, date, timeSlot);
        setResponseMessage(result.result);
        return result;
    }

    const hadleCloseAlertWindow = () => {
        setResponseMessage('');
    }

    if (responseMessage !== '') return <SystemMessage visibilityOfAlertWindow={responseMessage !== ''} message={responseMessage} onClose={hadleCloseAlertWindow} />
    return (
        <>

            <Form onSubmit={handleSubmit(onSubmit)}>
                <div >
                    <Container fluid>
                        {/* <h2 >Vyplňte Vaše údaje</h2> */}
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="name.validationCustom01">
                                <Form.Label>Jméno a příjmení*</Form.Label>
                                <Form.Control
                                    {...register("name", {
                                        required: true
                                    })}
                                    type="text"
                                    placeholder="Jméno"
                                    isInvalid={!!errors.name}
                                />
                                <Form.Control.Feedback type='invalid'>{noticeNonFilled}</Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="lastName.validationCustom02">
                                <Form.Label>Důvod návštěvy*</Form.Label>
                                <Form.Control
                                    {...register("reasonForVisit", {
                                        required: true
                                    })}
                                    type="text"
                                    placeholder="Důvod návštěvy"
                                    isInvalid={!!errors.reasonForVisit}
                                />
                                <Form.Control.Feedback type='invalid'>{noticeNonFilled}</Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                        <Row className='my-3'>
                            <Form.Group className="my-3">
                                <Form.Check
                                    // required
                                    {...register("occupationalMedicalCheckUp")}
                                    label="Pracovně lékařská prohlídka"
                                // feedback="You must agree before submitting."
                                // feedbackType="invalid"
                                />
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="phone.ControlInput2">
                                <Form.Label>Telefonní číslo</Form.Label>
                                <Form.Control
                                    {...register("phone", {
                                        pattern: /^[0-9]{9}$/,
                                        required: false,
                                        minLength: 9,
                                        maxLength: 9
                                    })}
                                    type="text"
                                    placeholder="777888999"
                                    isInvalid={!!errors.phone}
                                />
                                <Form.Control.Feedback type="invalid">Zadejte číslo v platném formátu: 777888999</Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                        <p>*povinné údaje</p>
                        <Row>
                            <Col className="d-flex justify-content-end mb-3" >
                                <Button type="submit" variant="primary">Odeslat</Button>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </Form>
        </>
    )
}

